import { render } from "./UserPhoto.vue?vue&type=template&id=e469b8bc&scoped=true"
import script from "./UserPhoto.vue?vue&type=script&lang=js"
export * from "./UserPhoto.vue?vue&type=script&lang=js"

import "./UserPhoto.vue?vue&type=style&index=0&id=e469b8bc&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e469b8bc"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QImg,QBtn,QTooltip});
